module.exports = __webpack_public_path__ + "img/swiggy.f72eb4dc.svg";